import React, { useState } from 'react'

import { Link, useLocation } from 'react-router-dom'

import style from './Header.module.css'
import { InfoModal } from './InfoModal/InfoModal'
import { ThemeSwitcher } from './ThemeSwitcher/ThemeSwitcher'

import { ReactComponent as InfoIcon } from 'assets/icons/info-icon.svg'
import logoImage from 'assets/images/logo.svg'
import { IconButton } from 'common/components'
import { Paths } from 'common/routes'
import { ResetButton } from 'features/dashboard'

export const Header = () => {
  const location = useLocation()
  const [isShowInfo, setIsShowInfo] = useState(false)

  return (
    <header className={style.header}>
      <div className={`container ${style.box}`}>
        <div className={style.logo}>
          <Link to="/">
            <img src={logoImage} alt="logo" />
          </Link>
        </div>
        <div className={style['button-box']}>
          <ThemeSwitcher />
          {location.pathname === Paths.Info && <ResetButton />}
          <IconButton callback={() => setIsShowInfo(true)} title="О приложении">
            <InfoIcon className={style['info-icon']} />
          </IconButton>
        </div>
      </div>
      <InfoModal isShowInfo={isShowInfo} setIsShowInfo={setIsShowInfo} />
    </header>
  )
}
